import * as XLSX from "xlsx";
import { SourceUsageTableRow } from "../../../components/SourceTable";
import { EXCEL_FILENAME, EXCEL_SHEET_NAME } from "../const";
import { rowsToExcelData } from "./rowsToExcelData";

/**
 * Builds an Excel workbook from domains rows and triggers file download.
 */
export function exportDomainsToExcel(rows: SourceUsageTableRow[]): void {
  const data = rowsToExcelData(rows);
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, EXCEL_SHEET_NAME);
  XLSX.writeFile(wb, EXCEL_FILENAME);
}
